import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';
import messages from './messages';

export const timezones = [
  { value: 'America/Vancouver', label: <FormattedMessage {...messages.pt} /> },
  { value: 'America/Edmonton', label: <FormattedMessage {...messages.mt} /> },
  { value: 'America/Inuvik', label: <FormattedMessage {...messages.nwt} /> },
  { value: 'America/Winnipeg', label: <FormattedMessage {...messages.ct} /> },
  { value: 'America/Toronto', label: <FormattedMessage {...messages.et} /> },
  { value: 'America/Halifax', label: <FormattedMessage {...messages.at} /> },
  {
    value: 'America/St_Johns',
    label: <FormattedMessage {...messages.nt} />,
  },
  {
    value: 'America/Swift_Current',
    label: <FormattedMessage {...messages.st} />,
  },
];

export const usTimezones = [
  {
    value: 'America/New_York',
    label: <FormattedMessage {...messages.usEt} />,
  },
  {
    value: 'America/Chicago',
    label: <FormattedMessage {...messages.usCt} />,
  },
  {
    value: 'America/Denver',
    label: <FormattedMessage {...messages.usMt} />,
  },
  {
    value: 'America/Phoenix',
    label: <FormattedMessage {...messages.usArizona} />,
  },
  {
    value: 'America/Los_Angeles',
    label: <FormattedMessage {...messages.usPt} />,
  },
  {
    value: 'America/Anchorage',
    label: <FormattedMessage {...messages.akt} />,
  },
  {
    value: 'Pacific/Honolulu',
    label: <FormattedMessage {...messages.ht} />,
  },
];

export const getTimezonesByCountry = (country) =>
  country === 'US' ? usTimezones : timezones;

export const intlTimezones = [
  {
    label: '(UTC-12:00) International Date Line West',
    value: 'Pacific/Wallis',
  },
  {
    label: '(UTC-11:00) Coordinated Universal Time-11',
    value: 'Pacific/Pago_Pago',
  },
  {
    label: '(UTC-10:00) Hawaii',
    value: 'US/Hawaii',
  },
  {
    label: '(UTC-09:00) Alaska',
    value: 'US/Alaska',
  },
  {
    label: 'Pacific Time (Vancouver)',
    value: 'Canada/Pacific',
  },
  {
    label: 'Mountain Time (Denver)',
    value: 'US/Mountain',
  },
  {
    label: 'Central Time (Chicago)',
    value: 'US/Central',
  },
  {
    label: 'Eastern Time (New York)',
    value: 'US/Eastern',
  },
  {
    label: '(UTC-04:30) Caracas',
    value: 'America/Caracas',
  },
  {
    label: 'Atlantic Time (Halifax)',
    value: 'Canada/Atlantic',
  },
  {
    label: 'Newfoundland Time (St. John’s)',
    value: 'Canada/Newfoundland',
  },
  {
    label: '(UTC-03:00) Greenland',
    value: 'America/Godthab',
  },
  {
    label: '(UTC-02:00) Mid-Atlantic - Old',
    value: 'America/Noronha',
  },
  {
    label: '(UTC-01:00) Azores',
    value: 'Atlantic/Azores',
  },
  {
    label: '(UTC) Coordinated Universal Time',
    value: 'Etc/Greenwich',
  },
  {
    label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    value: 'Europe/Amsterdam',
  },
  {
    label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    value: 'Europe/Helsinki',
  },
  {
    label: '(UTC+03:00) Nairobi',
    value: 'Africa/Nairobi',
  },
  {
    label: '(UTC+03:30) Tehran',
    value: 'Asia/Tehran',
  },
  {
    label: '(UTC+04:00) Abu Dhabi, Muscat',
    value: 'Asia/Muscat',
  },
  {
    label: '(UTC+04:30) Kabul',
    value: 'Asia/Kabul',
  },
  {
    label: '(UTC+05:00) Ashgabat, Tashkent',
    value: 'Asia/Tashkent',
  },
  {
    label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    value: 'Asia/Kolkata',
  },
  {
    label: '(UTC+05:45) Kathmandu',
    value: 'Asia/Katmandu',
  },
  {
    label: '(UTC+06:00) Ekaterinburg',
    value: 'Asia/Yekaterinburg',
  },
  {
    label: '(UTC+06:30) Yangon (Rangoon)',
    value: 'Asia/Rangoon',
  },
  {
    label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    value: 'Asia/Hong_Kong',
  },
  {
    label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    value: 'Asia/Tokyo',
  },
  {
    label: '(UTC+09:30) Adelaide',
    value: 'Australia/Adelaide',
  },
  {
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    value: 'Australia/Melbourne',
  },
  {
    label: '(UTC+11:00) Vladivostok',
    value: 'Asia/Vladivostok',
  },
  {
    label: '(UTC+12:00) Auckland, Wellington',
    value: 'Pacific/Auckland',
  },
  {
    label: '(UTC+13:00) Samoa',
    value: 'Pacific/Samoa',
  },
];

export const getTimezoneLabel = (value) => {
  let label = value;

  const countryTimezones = [...timezones, ...usTimezones];
  for (let index = 0; index < countryTimezones.length; index += 1) {
    if (countryTimezones[index].value === value) {
      ({ label } = countryTimezones[index]);
      return label;
    }
  }

  for (let index = 0; index < intlTimezones.length; index += 1) {
    if (intlTimezones[index].value === value) {
      ({ label } = intlTimezones[index]);
      return label;
    }
  }

  return label;
};

export function setMomentTimezone(timezone) {
  moment.tz.setDefault(timezone);
}

export const momentInTimezone = (date, timezone) => {
  const zonedDate = moment(date);

  if (timezone) {
    zonedDate.tz(timezone);
  }

  return zonedDate;
};

export const isSameAsDeviceTimezone = (dbTimezone) => {
  const getOffset = (timeZone = 'UTC', date = new Date()) => {
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
    const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
    return (utcDate.getTime() - tzDate.getTime()) / 6e4;
  };

  const year = new Date().getFullYear();
  const offsetDate = new Date(year, 0, 1);
  const DstOffsetDate = new Date(year, 6, 1);
  const deviceOffset = offsetDate.getTimezoneOffset();
  const deviceDstOffset = DstOffsetDate.getTimezoneOffset();
  const dbOffset = getOffset(dbTimezone, offsetDate);
  const dbDstOffset = getOffset(dbTimezone, DstOffsetDate);

  if (deviceOffset === dbOffset && deviceDstOffset === dbDstOffset) return true;

  return false;
};
